module.exports = __webpack_public_path__ + "img/c57.a9a80d20.png";